import { ReactElement, useState, useRef } from "react";
import { useOutsideClick } from "../../hooks/useOutsideClick";
import s from "./thumbnail.module.scss";
import { CaretUpIcon } from "../../assets/svgs/CaretUpIcon";

type ThumbnailProps = {
  name: string;
  dropdown: ReactElement;
  icon?: ReactElement;
};

export function TooltipThumbnail({ name, dropdown, icon }: ThumbnailProps) {
  const [collapse, setCollapse] = useState(false);
  const formattedName = name.split(" ");
  const containerRef = useRef<HTMLDivElement | null>(null);

  useOutsideClick(containerRef, () => setCollapse(false));

  return (
    <div
      ref={containerRef}
      className={[s["thumbnail"], "pointer"].join(" ")}
      onClick={() => setCollapse(!collapse)}
    >
      <p className={s["name"]}>
        {`${formattedName[0].charAt(0).toLocaleUpperCase()}${formattedName[1]
          .charAt(0)
          .toLocaleUpperCase()}`}
      </p>
      {icon ?? <CaretUpIcon className={collapse ? "" : "rotate-x-180"} />}
      {/* {icon ?? (
        <img
          src={CaretUp}
          alt="caret"
          className={collapse ? "" : "rotate-x-180"}
        />
      )} */}
      {collapse && dropdown}
    </div>
  );
}
